import React from 'react'
import SingleCategory from './singleCategory'
import { Wrapper } from './styles'
// import { inspectionSteps } from '../../../constants/dataList'
import { Card } from 'antd-mobile'
import { useCategoryList } from '../../../zustand/requests';

function CategoryList() {
    const categories = useCategoryList();
    const inspectionSteps = categories.data;
    let index = 0;
    return (
        <Wrapper>
            {inspectionSteps?.map(({ title:category, name, flashcards: items }, i) => {
                return (
                    <>
                        <Card
                            borderColor="red"
                            style={{
                                width: "100%", textAlign: "center",
                                border: `2px solid var(--border-${name})`,
                                backgroundColor: `var(--bg-${name})`
                            }}>
                            <b>
                                {category}
                            </b>
                        </Card>
                        {
                            items.map((data, j) => {
                                data = { ...data, i, j, category, name, index }
                                index++;
                                return (
                                    <SingleCategory {...data} />
                                )

                            })
                        }
                    </>
                )
            })}
        </Wrapper>
    )
}

export default CategoryList